import {Component, OnInit} from '@angular/core';
import {RecentProjectsService} from './recent-projects.service';

@Component({
  selector: 'sa-recent-projects',
  templateUrl: './recent-projects.component.html',
  providers: [RecentProjectsService]
})
export class RecentProjectsComponent implements OnInit {

  projects: Array<any>;
  currentMarket: string;
  constructor(private projectsService: RecentProjectsService) {

  }

  ngOnInit() {
    this.projects = this.projectsService.getProjects();
    //this.currentMarket = this.projects[1];
  }

  clearProjects() {
    this.projectsService.clearProjects();
    this.projects = this.projectsService.getProjects();

  }
  setMarket(market: string) {

    this.currentMarket = market;
  }
}
